/*
  HODL Vault – Goldschimmer (gehört zu vault-gold.css)
  1. Funkeln und Goldstaub: ein paar Punkte pro Bühne, nur animiert, solange die
     Bühne im Bild ist.
  2. Goldglanz über Verlaufswörtern: in Kopfbereichen nach dem Laden und danach
     selten wieder; bei Überschriften ohne Scroll-Timeline einmal beim Hineinscrollen.
  Bei reduzierter Bewegung oder Datensparmodus passiert nichts.
*/
(() => {
  const d = document;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (navigator.connection && navigator.connection.saveData) return;

  // [Bühne, Funken, Goldstaub, hinter dem Inhalt?] – ganze Abschnitte mit Text bekommen die Ebene dahinter
  const ZIELE = [
    ['.vhero__visual', 3, 14, false],
    ['.vgrav__plate', 5, 0, false],
    ['.vsig__bento', 3, 0, false],
    ['.vfin', 3, 12, true],
    ['.ast__stage', 3, 12, true],
    ['.acn__card', 2, 0, false],
    ['.vkon__card', 3, 0, false],
    ['.vkon', 0, 10, true],
    ['.vch', 3, 10, true],
    ['.vwt__hero', 3, 12, true],
    ['.vadv', 3, 14, true],
    ['.template-product .product__media-list .product__media-item:first-child .product__media', 3, 6, false],
  ];
  const KOPF_GLANZ = '.vhero__line--grad .vhero__txt, .ast__claim strong, .vch__title strong, .vwt__title strong';
  const H2_GLANZ = '.vs-h2 strong, .v-grad-text';
  const rnd = (a, b) => a + Math.random() * (b - a);
  const ease = 'cubic-bezier(0.45, 0, 0.2, 1)';

  const live = new IntersectionObserver((entries) => {
    entries.forEach((e) => e.target.classList.toggle('is-live', e.isIntersecting));
  }, { rootMargin: '120px 0px' });

  const fill = (box, sparks, dust, back) => {
    if (box.dataset.vgold) return;
    box.dataset.vgold = '1';
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    // Hinter dem Inhalt, aber vor dem Hintergrund des Abschnitts
    if (back) box.style.isolation = 'isolate';
    const layer = d.createElement('span');
    layer.className = back ? 'v-goldlayer v-goldlayer--back' : 'v-goldlayer';
    layer.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < sparks; i += 1) {
      const s = d.createElement('i');
      const dur = rnd(6, 11);
      s.className = 'v-spark';
      s.style.cssText = `--x:${rnd(8, 92).toFixed(1)}%;--y:${rnd(10, 90).toFixed(1)}%;--s:${rnd(8, 15).toFixed(1)}px;--d:${dur.toFixed(1)}s;--w:${(-rnd(0, dur)).toFixed(1)}s;--o:${rnd(0.65, 0.95).toFixed(2)}`;
      layer.appendChild(s);
    }
    for (let i = 0; i < dust; i += 1) {
      const p = d.createElement('i');
      const dur = rnd(12, 22);
      p.className = 'v-dust';
      p.style.cssText = `--x:${rnd(4, 96).toFixed(1)}%;--y:${rnd(30, 98).toFixed(1)}%;--s:${rnd(1.5, 3.5).toFixed(1)}px;--d:${dur.toFixed(1)}s;--w:${(-rnd(0, dur)).toFixed(1)}s;--o:${rnd(0.25, 0.6).toFixed(2)};--dx:${rnd(-22, 22).toFixed(0)}px;--dy:${(-rnd(60, 140)).toFixed(0)}px`;
      layer.appendChild(p);
    }
    box.appendChild(layer);
    live.observe(layer);
  };

  const glint = (el) => {
    if (!el.animate) return;
    el.animate(
      [{ backgroundPosition: '115% 0, 0 0' }, { backgroundPosition: '-15% 0, 0 0' }],
      { duration: 1700, easing: ease }
    );
  };

  // Kopfbereiche: erster Glanz nach dem Aufbau, danach alle 11–15 Sekunden, solange sichtbar
  const kopf = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const el = e.target;
      clearTimeout(el._vgoldT);
      if (!e.isIntersecting) return;
      const loop = (wait) => {
        el._vgoldT = setTimeout(() => { glint(el); loop(rnd(11000, 15000)); }, wait);
      };
      loop(el._vgoldSeen ? rnd(4000, 7000) : 2600);
      el._vgoldSeen = true;
    });
  }, { threshold: 0.4 });

  // Überschriften ohne Scroll-Timeline: einmal beim Hineinscrollen
  const timeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  const h2 = timeline ? null : new IntersectionObserver((entries, obs) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      glint(e.target);
      obs.unobserve(e.target);
    });
  }, { threshold: 0.6 });

  const init = (scope = d) => {
    ZIELE.forEach(([sel, sparks, dust, back]) => {
      scope.querySelectorAll(sel).forEach((box) => fill(box, sparks, dust, back));
    });
    scope.querySelectorAll(KOPF_GLANZ).forEach((el) => {
      if (el.dataset.vgoldG) return;
      el.dataset.vgoldG = '1';
      kopf.observe(el);
    });
    if (h2) {
      scope.querySelectorAll(H2_GLANZ).forEach((el) => {
        if (el.dataset.vgoldG) return;
        el.dataset.vgoldG = '1';
        h2.observe(el);
      });
    }
  };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', () => init());
  else init();
  d.addEventListener('shopify:section:load', (e) => init(e.target));
})();
